import { ConfigurationKeys } from './ConfigurationKeys'
import { SelectedConfigurationKeys } from './SelectedConfigurationKeys'

export {
    ConfigurationKeys,
    SelectedConfigurationKeys
}

(function ($) {
    if (location.pathname != "/Configuration" || !location.hash)
        return;
    $(document).ready(function () {
        var top = document.documentElement.scrollTop;
        var el = $(location.hash);
        var fieldName = location.hash.replace('configurationItem_', '');
        var initColor = $(fieldName).css('border-color');
        $(fieldName)[0].onfocus = function (e) { $(fieldName).css('border-color', initColor) }
        window.setTimeout(function () {
            //We need to scroll a little more due to the effect of the fixed navigation bar.
            document.documentElement.scrollTop = top - el.outerHeight(true);
            $(fieldName).css('border-color', 'red');
        }, 10);
    });
})(jQuery);


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/ConfigurationOverview/index.ts
 **/